// @ts-nocheck
/* eslint-disable */

  /**
  * Do not change! File was auto generate. 
  *
  */
  
import React from 'react';

import { ReactComponent as PrizeComponent} from './Prize.svg';

import Icon, { TIconProps } from '../Icon';

export const IconPrize = React.forwardRef<any, TIconProps>((props, ref) => (
  <Icon
    ref={ref}
    {...props}
  >
    <PrizeComponent/>
  </Icon>
));
